import clsx from 'clsx';

import { TypographyProps } from './types';

const Typography = ({ variant = 'body', className, children, ...props }: TypographyProps) => {
  const Tag = variant === 'body' ? 'p' : variant;

  const variants: Record<TypographyProps['variant'], string> = {
    h1: 'text-4xl font-bold',
    h2: 'text-3xl font-bold',
    h3: 'text-2xl font-semibold',
    h4: 'text-xl font-semibold',
    h5: 'text-lg font-semibold',
    h6: 'text-base font-semibold',
    body: 'text-base',
    caption: 'text-sm text-gray-500',
  };

  return (
    <Tag {...props} className={clsx(variants[variant], className)}>
      {children}
    </Tag>
  );
};

export default Typography;
